export enum IframeMessageType {
  MODAL_OPEN = 'MODAL_OPEN',
  MODAL_CLOSE = 'MODAL_CLOSE',
  IMAGE_SELECTED = 'IMAGE_SELECTED',
  CONTENT_LOADED = 'CONTENT_LOADED',
}

export enum ModalType {
  AI_IMPACT = 'AI_IMPACT',
  ONBOARDING = 'ONBOARDING',
  PATIENT_EDUCATION = 'PATIENT_EDUCATION',
  PRINT_DOWNLOAD = 'PRINT_DOWNLOAD',
  QR_CODE = 'QR_CODE',
  UPGRADE = 'UPGRADE',
}

export interface ModalOpenPayload {
  type: string;
  externalPatientId: string | null;
  externalImageId: string | null;
  patientId: string | null;
  imageId: string | null;
}

// Message schema types for RCI to VideaAI iFrame communication
export interface ModalOpenMessage {
  type: string;
  payload: ModalOpenPayload;
}

export interface ImageSelectedMessage {
  type: string;
  payload: {
    imageId: string;
  };
}

export interface ModalCloseMessage {
  type: string;
  payload?: {
    type?: string;
  };
}

export interface ExternalPatientContextType {
  isIframe: boolean;
  externalPatientId: string | null;
  externalImageId: string | null;
  patientId: string | null;
  imageId: string | null;
}

export enum TrialStatus {
  CANCEL_REQUEST = 'CANCEL_REQUEST', // Only used in mutation to either cancel free trial or request cancellation of paid subscription
  CANCEL_REQUEST_PROVISIONAL = 'CANCEL_REQUEST_PROVISIONAL', // User requested cancellation but Salesforce hasn't ceased billing, returned in get request
  CANCEL_REQUEST_PAID = 'CANCEL_REQUEST_PAID', // Paid subscription was fully cancelled, returned in get request
  CANCEL_REQUEST_TRIAL = 'CANCEL_REQUEST_TRIAL', // Free trial was cancelled, returned in get request
  PAID = 'PAID', // Paid subscription
  PAID_BUT_PROVISIONAL = 'PAID_BUT_PROVISIONAL', // Sent to BE when upgrading from trial
  TRIAL = 'TRIAL', // Free trial
  TRIAL_ELIGIBLE = 'TRIAL_ELIGIBLE', // Free trial offered
  TRIAL_EXPIRED = 'TRIAL_EXPIRED', // Free trial expired
}

export interface TrialStatusData {
  createdAt: string;
  createdBy: string;
  externalPracticeId: string;
  paidEndedOn: string;
  paidStartedOn: string;
  practiceId: number;
  status: TrialStatus;
  trialEndedOn: string;
  trialEndsOn: string;
  trialStartedOn: string;
  updatedAt: string;
  updatedBy?: string;
  videaPracticeId: string;
}

export type CancelCheckboxReason =
  | 'MISSING_FEATURES'
  | 'NOT_USING_ENOUGH'
  | 'DIFFICULT_TO_USE'
  | 'COST'
  | 'SWITCHING_TO_OTHER_PRODUCT'
  | 'OTHER';
